export enum EProductTypes {
    BESTSELLER = 'BESTSELLER',
    TOP_RATED = "TOP_RATED",
    MOST_LOVED = "MOST_LOVED",
    HOT_NOW = "HOT_NOW",
    CUSTOMER_FAVOURITE = "CUSTOMER_FAVOURITE",
    JUST_DROPPED = "JUST_DROPPED",
    SEASON_SPECIAL = "SEASON_SPECIAL",
    TRENDING_NOW = "TRENDING_NOW",
    DISCOUNTED = "DISCOUNTED",
    PRODUCT_BUNDLE = "PRODUCT_BUNDLE",
    FREQUENTLY_ORDER = "FREQUENTLY_ORDER",
}
